import { render, staticRenderFns } from "./layoutMobile.vue?vue&type=template&id=7c406ef9&scoped=true"
import script from "./layoutMobile.vue?vue&type=script&lang=js"
export * from "./layoutMobile.vue?vue&type=script&lang=js"
import style0 from "./layoutMobile.vue?vue&type=style&index=0&id=7c406ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c406ef9",
  null
  
)

export default component.exports